import { Injectable, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { PermRole } from '@/models/user-data.model';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  baseUrl = environment.landmark_API_URL + '/perms';

  roles = signal<PermRole[]>([]);

  selectedRole = signal<PermRole | null>(null);

  constructor(private http: HttpClient) { 
    this.populateRoles();
  }

  updateRoles(roles: PermRole[]) {
    this.roles.set(roles);
  }

  addRoles(roles: PermRole[]) {
    this.roles.set([...this.roles(), ...roles]);
  }

  removeRole(roleId: number): Observable<any> {
    return this.deleteRole(roleId).pipe(
      tap((removedRole: any) => {
        this.roles.set(this.roles().filter(role => role.PermRoleID !== removedRole.PermRoleID));
      })
    );
  }

  //===============roles===================

  addRole(newNote: any) {
    return this.http.post(`${this.baseUrl}/notes/`, newNote);
  }

  getRoles(): Observable<PermRole[]> {
    return this.http.get<PermRole[]>(`${this.baseUrl}/roles/`);
  }

  updateRole(roleId: number, changes: any): Observable<PermRole> {
    return this.http.put<PermRole>(`${this.baseUrl}/roles/${roleId}`, changes);
  }

  private deleteRole(roleId: number) {
    return this.http.delete(`${this.baseUrl}/roles/${roleId}`);
  }

  populateRoles() {
    this.getRoles().subscribe(roles => {
      this.roles.set(roles);
      console.log('roles', roles);
    });
  }

}
